import {
  axios
} from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {

  findByList({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/companyProfile/findByList`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  findById({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/companyProfile/findById`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  save({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/companyProfile/save`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  upload({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/file/upload`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  uploadTrue({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/seafile/uploadFile`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
}
